import { AppThunkDispatch } from '@Reducers/index';

import { CompanyApi } from '@ClientApi/company';
import { IAmazonBusinessConnection } from '@Shared/api_responses/amazonBusinessConnection';
import { IAccountingConnectionModel, ISalesforceConnectionModel, ISlackConnectionModel } from '@Shared/models';

export const SET_ACCOUNTING_CONNECTION = 'SET_ACCOUNTING_CONNECTION';
export const SET_SALESFORCE_CONNECTION = 'SET_SALESFORCE_CONNECTION';
export const SET_SLACK_CONNECTION = 'SET_SLACK_CONNECTION';
export const SET_AMAZON_BUSINESS_CONNECTION = 'SET_AMAZON_BUSINESS_CONNECTION';
export const SET_EMBURSE_CARDS_CONNECTIONS = 'SET_EMBURSE_CARDS_CONNECTIONS';
export const SET_LOADING_EMBURSE_CARDS_CONNECTIONS = 'SET_LOADING_EMBURSE_CARDS_CONNECTIONS';

export class SetAccountingConnection {
  readonly type = SET_ACCOUNTING_CONNECTION;
  readonly payload: IAccountingConnectionModel;

  constructor(accountingConnection: IAccountingConnectionModel) {
    this.payload = accountingConnection;
  }
}

export class SetSalesforceConnection {
  readonly type = SET_SALESFORCE_CONNECTION;
  readonly payload: ISalesforceConnectionModel;

  constructor(public salesforceConnection: ISalesforceConnectionModel) {
    this.payload = salesforceConnection;
  }
}

export class SetSlackConnection {
  readonly type = SET_SLACK_CONNECTION;
  readonly payload: ISlackConnectionModel;

  constructor(public slackConnection: ISlackConnectionModel) {
    this.payload = slackConnection;
  }
}

export class SetAmazonBusinessConnection {
  readonly type = SET_AMAZON_BUSINESS_CONNECTION;
  readonly payload: IAmazonBusinessConnection;

  constructor(public slackConnection: IAmazonBusinessConnection) {
    this.payload = slackConnection;
  }
}

export class SetEmburseCardsConnections {
  readonly type = SET_EMBURSE_CARDS_CONNECTIONS;
  readonly payload: any[];

  constructor(public emburseCardsConnections: any[]) {
    this.payload = emburseCardsConnections;
  }
}

export class SetLoadingEmburseCardsConnections {
  readonly type = SET_LOADING_EMBURSE_CARDS_CONNECTIONS;
  readonly payload: boolean;

  constructor(public loadingState: boolean) {
    this.payload = loadingState;
  }
}

export const getEmburseCardsConnections = (companyId: string) => async (dispatch: AppThunkDispatch) => {
  dispatch(new SetLoadingEmburseCardsConnections(true));
  try {
    const connections = await CompanyApi.getCompanyGatewayConnections(companyId);
    const emburseCardsConnections = connections?.filter((connection: any) => connection?.feedBackend === 'emburse_cards');
    if (emburseCardsConnections.length === 0 || (emburseCardsConnections.length === 1 && emburseCardsConnections[0] === null)) {
      dispatch(new SetEmburseCardsConnections([]));
    } else {
      dispatch(new SetEmburseCardsConnections(emburseCardsConnections));
    }
  } finally {
    dispatch(new SetLoadingEmburseCardsConnections(false));
  }
};

export type ConnectionsAction =
  | SetAccountingConnection
  | SetSalesforceConnection
  | SetSlackConnection
  | SetAmazonBusinessConnection
  | SetEmburseCardsConnections
  | SetLoadingEmburseCardsConnections;
